import { apiClientWithRefreshToken } from "@/api/apiClient";
import { SaveTimeSheetSchema } from "@/v2/schema/time-sheet";
import { EmployeeTimeSheet } from "@/v2/types";

export default async function SaveTimeSheet({
    timeSheetId,
    data,
}: {
    timeSheetId: string;
    data: SaveTimeSheetSchema;
}): Promise<EmployeeTimeSheet[]> {
    const res = await apiClientWithRefreshToken({
        url: `/time-sheets/${timeSheetId}`,
        method: "PUT",
        data: data,
    });

    return res.data;
}
